/**
 * Bucket units for Reports → Unit Status: the counts on the card AND the unit
 * lists click-to-focus sends (T-069) come from this one function, so they can
 * never disagree.
 *
 * The live polled status (UnitStatusProvider, every 15 s) wins over the
 * status from the one-time fleet load, so the buckets stay current while the
 * page is open. Idle/Charging includes unknown, as the card always has;
 * statuses the card never counted (degraded, suspended) stay out of every
 * bucket.
 */
export interface StatusBuckets {
  online: string[];
  offline: string[];
  idle: string[];
}

type LiveStatuses = ReadonlyMap<string, { status: string }>;

export function bucketUnitStatuses(
  units: ReadonlyArray<{ id: string; status?: string | null }>,
  live?: LiveStatuses,
): StatusBuckets {
  const buckets: StatusBuckets = { online: [], offline: [], idle: [] };
  for (const unit of units) {
    const status = live?.get(unit.id)?.status ?? unit.status ?? 'unknown';
    if (status === 'online') buckets.online.push(unit.id);
    else if (status === 'offline') buckets.offline.push(unit.id);
    else if (status === 'idle' || status === 'unknown') buckets.idle.push(unit.id);
  }
  return buckets;
}
